import chroma from "chroma-js";
const contrastRatios = {
  AA: 4.5,
  // https://www.w3.org/TR/WCAG21/#contrast-minimum
  AALarge: 3,
  AAA: 7,
  // https://www.w3.org/TR/WCAG21/#contrast-enhanced
  AAALarge: 4.5
};
const contrastingColor = (color, wcagLevel = "AAA") => {
  const mixStep = 0.05;
  const mixColor = chroma(color).luminance() < 0.5 ? "#fff" : "#000";
  let mixture = 0;
  let outputColor = chroma.mix(color, mixColor, mixture).hex();
  while (mixture <= 1) {
    outputColor = chroma.mix(color, mixColor, mixture).hex();
    if (chroma.contrast(color, outputColor) >= contrastRatios[wcagLevel]) {
      break;
    }
    mixture += mixStep;
  }
  return outputColor;
};
export default contrastingColor;
